// Contact.js
import React from 'react';
import AnimateOnScroll from './AnimateOnScroll';
import './Contact.css';
import { FaEnvelope, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';
import { buildWhatsAppUrl, WHATSAPP_DISPLAY } from '../constants/whatsapp';

const Contact = () => (
  <section className="contact" id="contact">
    <div className="mission-vision">
      <AnimateOnScroll variant="fadeUp">
        <div className="section-header">
          <h2>Nossa Essência</h2>
        </div>
      </AnimateOnScroll>
      
      <AnimateOnScroll variant="fadeUp" delay={100}>
      <div className="values-container">
        <div className="value-card vision">
          <h3>Visão</h3>
          <p>
            Ser reconhecida como uma referência em soluções tecnológicas inovadoras na área
            da saúde, focando na revolução do tratamento por meio de tecnologias interativas,
            gamificação e monitoramento remoto, contribuindo para a melhoria da qualidade de
            vida dos pacientes e para a eficiência e eficácia dos profissionais de saúde.
          </p>
        </div>

        <div className="value-card mission">
          <h3>Missão</h3>
          <p>
            Desenvolver soluções tecnológicas acessíveis e eficazes que integrem inovação,
            gamificação e tecnologia avançada para atender às necessidades de profissionais da
            saúde e pacientes.
          </p>
        </div>
      </div>
      </AnimateOnScroll>
    </div>

    <div className="contact-section">
      <AnimateOnScroll variant="fadeUp">
        <div className="section-header">
          <h2>Fale Conosco</h2>
        </div>
      </AnimateOnScroll>

      <AnimateOnScroll variant="fadeUp" delay={100}>
      <div className="contact-container">
        <div className="contact-card">
          <div className="contact-group">
            <h4>E-mail</h4>
            <a href="mailto:contato@bientech.com.br" className="contact-link">
              <FaEnvelope /> contato@bientech.com.br
            </a>
          </div>

          <div className="contact-group">
            <h4>WhatsApp</h4>
            <a
              href={buildWhatsAppUrl('Olá! Vim pelo site da Bientech e gostaria de mais informações.')}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link whatsapp"
            >
              <FaWhatsapp /> WhatsApp oficial — {WHATSAPP_DISPLAY}
            </a>
          </div>

          <div className="contact-group">
            <h4>Redes Sociais</h4>
            <div className="social-list">
              <a href="https://www.instagram.com/bientechsaudeetecnologia/" target="_blank" rel="noopener noreferrer" className="contact-link instagram">
                <FaInstagram /> Instagram
              </a>
              <a href="https://www.linkedin.com/company/bientech/" target="_blank" rel="noopener noreferrer" className="contact-link linkedin">
                <FaLinkedin /> LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
      </AnimateOnScroll>
    </div>
  </section>
);

export default Contact;
